import strFunc from "@/lib/lyg/string";

function StudyListArea(props: any) {
  let myProps = {
    Style: {},
    study_use_info: null,
    section_seq: "",
    open_word_group_result_popup: (inData: any) => { },
    ...props
  };
  let Style = myProps.Style;
  let study_use_info = myProps.study_use_info;
  let section_seq = myProps.section_seq;
  let study_list: any = [];
  if (study_use_info && study_use_info["study_arr"]) {
    for (let i = 0; i < study_use_info["study_arr"].length; i++) {
      if (study_use_info["study_arr"][i]["a_section_seq"] == section_seq) {
        study_list.push(study_use_info["study_arr"][i]);
      }
    }
  }

  const get_study_list_detail = (inData: any) => {
    let opt_obj = {
      study_title_seq: "",
      study_seq: "",
      ...inData
    };
    let study_use_detail = null;
    if (study_use_info && study_use_info["detail_arr"]) {
      for (let i = 0; i < study_use_info["detail_arr"].length; i++) {
        let detail_item = study_use_info["detail_arr"][i];
        if (opt_obj.study_title_seq == detail_item.a_study_title_seq
          && opt_obj.study_seq == detail_item.a_seq) {
          study_use_detail = detail_item;
        }
      }
    }
    return study_use_detail;
  };

  const get_study_list_tags = () => {
    let study_list_tags = study_list.map((item: any, idx: number) => {
      let study_use_detail = get_study_list_detail({
        study_title_seq: item.a_title_seq,
        study_seq: item.a_seq
      });
      let success_per: any = "";
      let success_cnt = "";
      let success_tot = "";
      let date_str = "";
      let row_stu_seq="";
      if (study_use_detail != null) {
        success_per = study_use_detail.a_success_record + "%";
        if (study_use_detail.a_is_success == "1") {
          success_per = "100%";
        }
        success_cnt = study_use_detail.a_success_amount;
        success_tot = study_use_detail.a_amount;
        date_str = study_use_detail.a_update_date.substring(0, 10);
        row_stu_seq = study_use_detail.a_stu_seq;
      }
      return (
        <tr key={idx}>
          <td>{item.a_title}</td>
          <td>
            {!strFunc.is_empty(success_cnt) &&
              <span>
                <span>
                  {success_cnt}/{success_tot}
                </span>
                {(!strFunc.is_empty(item["a_par_id"])&&!strFunc.is_empty(item["a_par_seq"]))&&
                <span>
                  <button className="btn btn-dark ml-1"
                    onClick={()=>{
                      myProps.open_word_group_result_popup({
                        g_par_id: "study_list",
                        g_par_seq: item["a_title_seq"]+","+item["a_seq"],
                        stu_seq: row_stu_seq
                      });
                    }}>결과보기</button>
                </span>
                }
              </span>
            }
          </td>
          <td>{success_per}</td>
          <td>{date_str}</td>
        </tr>
      );
    });

    return study_list_tags;
  };

  return (
    <div className={Style.study_list_wrap} >
      <table className={Style.study_list_table}>
        <colgroup>
          <col width={"20%"}></col>
          <col width={"20%"}></col>
          <col width={"20%"}></col>
          <col width={"20%"}></col>
        </colgroup>
        <tbody>
          {get_study_list_tags()}
        </tbody>
      </table>
    </div>
  );
};
export default StudyListArea;